module.exports = __webpack_public_path__ + "img/greg-rutkowski-battle.5513f7b5.jpg";